import { FaRegUser } from 'react-icons/fa'

import { UserRegistry } from '../Components/UserRegistry'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Деактивовані співробітники» (`SPEC-005` §7.1, С3.2). У боковому меню не
 * перелічена: потрапляють сюди верхнім меню розділу. Звідси співробітника
 * активують знову — перемикачем «Активність» у картці.
 */
export const UserInactivePage = () => <UserRegistry kind="inactive" />

export default UserInactivePage

export const pageConfig: IPageConfig = {
    key: 'Setting.UserInactive',
    route: '/users/inactive',
    title: 'Деактивовані співробітники',
    icon: <FaRegUser />,
}
